import { FaHandHoldingHeart, FaUsers } from "react-icons/fa";
import { FaPuzzlePiece } from "react-icons/fa";

// Componentes de iconos usando react-icons
const IndustryIcon = () => (
  <FaHandHoldingHeart className="w-12 h-12 sm:w-14 sm:h-14 text-white" />
);

const NetworkIcon = () => (
  <FaUsers className="w-12 h-12 sm:w-14 sm:h-14 text-white" />
);

const PuzzleIcon = () => (
  <FaPuzzlePiece className="w-12 h-12 sm:w-14 sm:h-14 text-white" />
);

// Componente InfoBlock reutilizable
const InfoBlock = ({ gradient, title, icon: Icon, description }) => (
  <div
    className={`w-full sm:w-[80%] md:w-[45%] lg:w-[30%] xl:w-[28%] h-auto min-h-[180px] sm:min-h-[200px] rounded-[60px] bg-gradient-to-br ${gradient} p-5 sm:p-6 text-center`}
  >
    <h3 className="text-base sm:text-lg md:text-xl font-bold mb-3 sm:mb-4">
      {title}
    </h3>
    <div className="flex justify-center mb-3 sm:mb-4">
      <Icon />
    </div>
    <p className="text-xs sm:text-sm opacity-90">{description}</p>
  </div>
);

// Configuración de los bloques
const blocksData = [
  {
    id: 1,
    gradient: "from-[#29265b] to-[#2a3180]",
    title: "Te abrimos las puertas de la industria",
    icon: IndustryIcon,
    description: "Posicionamos tu marca con tomadores de decisiones",
  },
  {
    id: 2,
    gradient: "from-[#2a3180] to-[#1e72b9]",
    title: "Enlaces directos con grandes empresas",
    icon: NetworkIcon,
    description:
      "Accede a citas de trabajo y conoce de primera mano las necesidades de proveeduría de las grandes empresas.",
  },
  {
    id: 3,
    gradient: "from-[#1e72b9] to-[#39a8e0]",
    title: "Somos una red de negocio B2B exclusiva",
    icon: PuzzleIcon,
    description:
      "Generamos negocios en el ramo industrial que permiten el crecimiento acelerado de tu empresa.",
  },
];

function InfoBlocks() {
  return (
    <section className="flex justify-center flex-wrap gap-4 sm:gap-5 md:gap-6 px-4 sm:px-6 md:px-8 lg:px-10 py-4 sm:py-6 md:py-8 text-white">
      {blocksData.map((block) => (
        <InfoBlock
          key={block.id}
          gradient={block.gradient}
          title={block.title}
          icon={block.icon}
          description={block.description}
        />
      ))}
    </section>
  );
}

export default InfoBlocks;
